<div class="w-full flex flex-col items-center">
    @if (cookiesEnabled()) {
    @switch (loginPage()) {
    @case (loginTypeTopbar) {
    <h2 class="text-center text-2xl font-semibold font-mulish">Welcome back!</h2>

    <p class="text-center text-gray-600 mt-4 md:mt-6 text-xl font-mulish">
        Don't have an account? <br class="block lg:hidden">
        <a class="cursor-pointer" (click)="openRegisterModal()">Register</a> to start bidding
    </p>
    }
    @case (loginTypeTickets) {
    <h2 class="text-center text-2xl font-semibold font-mulish">Sign in to speed up checkout!</h2>

    <p class="text-center text-gray-600 mt-4 md:mt-6 text-lg font-mulish">
        Have an account? <br class="block lg:hidden">
        Sign in to use saved cards for a faster checkout!
    </p>
    }
    @case (loginTypeRegister) {
    <h2 class="text-center text-2xl font-semibold font-mulish">Welcome!</h2>

    <p class="text-center text-gray-600 mt-4 md:mt-6 text-lg font-mulish">
        Already have an account? <a class="cursor-pointer" (click)="openLoginModal()">Sign in</a>
    </p>
    }
    @case (loginTypePasswordReset) {
    <h2 class="text-center text-2xl font-semibold font-mulish">Reset Password</h2>

    <p class="text-center text-gray-600 mt-4 md:mt-6 text-lg font-mulish">
        Please enter a new password for your account.
    </p>
    }
    @case (loginTypeCompleteRegistration) {
    <h2 class="text-center text-2xl font-semibold font-mulish">Complete Your Registration</h2>

    <p class="text-center text-gray-600 mt-4 md:mt-6 text-lg font-mulish">
        Set a password and agree to the Terms of Use to get started.
    </p>
    }
    }

    <iframe id="login-iframe" [src]="safeLoginUrl()" [class]="iframeClass()"></iframe>

    @switch (loginPage()) {
    @case (loginTypeTopbar) {
    <p class="text-center text-gray-600 text-xl font-mulish -mt-[25px]">
        Don't have an account? <br class="block lg:hidden">
        <a class="cursor-pointer" (click)="openRegisterModal()">Register</a> to start bidding
    </p>
    }
    @case (loginTypeTickets) {
    @if (!hideGuestOption()) {
    <button class="bfg-button-outline w-[300px] lg:w-[634px] -mt-[40px]" (click)="continueAsGuest()">Continue as
        Guest</button>
    }
    }
    @case (loginTypeRegister) {
    <p class="text-center text-gray-600 mt-4 md:mt-6 text-lg font-mulish">
        Already have an account? <a class="cursor-pointer" (click)="openLoginModal()">Sign in</a>
    </p>
    }
    }
    } @else {
    <h2 class="text-center text-2xl font-semibold font-mulish mx-12">Cookies are disabled</h2>

    <p class="text-center text-gray-600 mt-4 md:mt-6 text-lg font-mulish">
        Please enable cookies to sign in.
    </p>
    }
</div>